import React from 'react';

import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';

import { theme, Illustration } from 'fpay-ui';

const Layout = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    background-color: ${theme.colors.gray200};
    margin: 0;
    margin-top: 32px;
  `
);

const Container = styled.div`
  background-color: #fff;
  width: 100%;
  min-height: 185px;
  display: flex;
  border-radius: 6px;
  flex-direction: column;
  align-items: center;
  ${theme.breakpoint('md')} {
    border-radius: 6px;
    width: 100%;
    min-height: 205px;
  }
  ${theme.breakpoint('ll')} {
    border-radius: 6px;
    width: 100%;
    min-height: 254px;
  }
`;

const ContainerHeader = styled.div`
  display: none;
  ${theme.breakpoint('md')} {
    display: flex;
    width: 100%;
    display: flex;
    flex-direction: row;
    background-color: ${theme.colors.gray200};
    justify-content: space-between;
    margin-bottom: 10px;
  }
`;

const ContainerHeaderText = styled.div`
  display: none;
  @media (min-width: 701px) {
    display: flex;
    ${({ theme }) => theme.textTypes['Caption-w400']};
    color: ${theme.colors.gray700};
    text-align: center;
    margin-left: 24px;
    margin-right: 24px;
  }
  @media (min-width: 951px) {
    ${({ theme }) => theme.textTypes['Overline-w500']};
    color: ${theme.colors.gray700};
    line-height: 1.3;
    letter-spacing: 0.16px;
    text-align: center;
  }
`;

const ImageNotFound = styled(Illustration)(
  css`
    width: 150px;
    ${theme.breakpoint('md')} {
    }
    ${theme.breakpoint('ll')} {
      margin-top: 48px;
    }
  `
);

const ContainerText = styled.div`
  max-width: 336px;
  ${({ theme }) => theme.textTypes['Body-2-w400']};
  line-height: 1.25;
  color: ${theme.colors.gray700};
  text-align: center;
  margin-top: 8px;
  margin-bottom: 52px;
`;

const ContainerTextTitle = styled.div`
  max-width: 336px;
  margin-top: -50px;
  ${({ theme }) => theme.textTypes['Subtitle-1-w400']};
  line-height: 1.25;
  color: ${theme.colors.gray800};
  text-align: center;
`;

const NotFoundLastMovements = () => {
  const { t } = useTranslation();
  return (
    <Layout>
      <ContainerHeader>
        <ContainerHeaderText>FECHA</ContainerHeaderText>
        <ContainerHeaderText>CÓDIGO</ContainerHeaderText>
        <ContainerHeaderText>TIPO</ContainerHeaderText>
        <ContainerHeaderText>DETALLE</ContainerHeaderText>
        <ContainerHeaderText>MONTO</ContainerHeaderText>
      </ContainerHeader>
      <Container>
        <ImageNotFound name="no_search_result" alt="Sin Resultados" />
        <ContainerTextTitle>{t('lastMovements.notFound')}</ContainerTextTitle>
        <ContainerText>{t('lastMovements.notFoundDescription')}</ContainerText>
      </Container>
    </Layout>
  );
};

export default NotFoundLastMovements;
